import React, { useEffect, useState } from "react";
import './article.css';
import { useParams } from 'react-router';

const Article = () => {
    const { name } = useParams();
    const [fileContent, setFileContent] = useState("");

    useEffect(() => {
        fetch(`/articles/${name}.html`)
            .then(response => {
                if (!response.ok) {
                    setFileContent('Статья не найдена');
                }
                return response.text();
            })
            .then(data => setFileContent(data))
            .catch(error => setFileContent("Ошибка: " + error.message));
    }, [name]);
    
    return <div className='block-content'>
        <div dangerouslySetInnerHTML={{ __html: fileContent }}></div>
    </div>    
}

export default Article;